import axios from "axios";
import { API_BASE_URL } from "../constants/ApiConfig";
import { getToken, removeToken } from "../utils/helperFunctions/tokenStorage";

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 15000,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "X-Client-Source": "admin-panel",
  },
});

apiClient.interceptors.request.use(async (config) => {
  const token = await getToken();

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error?.response?.status === 401) {
      await removeToken();
      window.location.href = "/login";
    }

    return Promise.reject(error);
  },
);

export default apiClient;
